// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#index[data-v-dac4ca3c] {\n    display: block;\n    width: 100vw;\n    height: 100vh;\n    font-family: Verdana;\n}\n", ""]);
// Exports
module.exports = exports;
